import { FC } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../../utils/cn';
import type { TherapistDashboardSection } from '../../../types/therapist-dashboard.types';

interface UserMenuProps {
  userName: string | undefined;
  isOpen: boolean;
  onToggle: () => void;
  onSectionChange: (section: TherapistDashboardSection) => void;
  onLogout: () => void;
}

export const UserMenu: FC<UserMenuProps> = ({
  userName,
  isOpen,
  onToggle,
  onSectionChange,
  onLogout,
}) => {
  const handleMenuAction = (section: TherapistDashboardSection) => {
    onSectionChange(section);
    onToggle();
  };

  const handleLogoutClick = () => {
    onLogout();
    onToggle();
  };

  return (
    <div className="relative">
      <button
        onClick={onToggle}
        className="flex items-center space-x-3 pl-4 border-l border-gray-200 dark:border-slate-700 hover:bg-gray-50 dark:hover:bg-slate-700 rounded-lg px-3 py-2 transition-colors"
      >
        <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/50 flex items-center justify-center text-blue-600 dark:text-blue-400 font-semibold">
          {userName?.charAt(0) || 'T'}
        </div>
        <div className="hidden md:block text-left">
          <p className="text-sm font-medium text-gray-900 dark:text-slate-100">{userName}</p>
          <p className="text-xs text-gray-500 dark:text-slate-400">Therapist</p>
        </div>
        <ChevronDown
          className={cn(
            'w-5 h-5 text-gray-400 dark:text-slate-500 transition-transform',
            isOpen && 'transform rotate-180'
          )}
        />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-white dark:bg-slate-800 rounded-lg shadow-lg border border-gray-200 dark:border-slate-700 py-2">
          <button
            onClick={() => handleMenuAction('profile')}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
          >
            My Profile
          </button>
          <button
            onClick={() => handleMenuAction('availability')}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
          >
            Manage Availability
          </button>
          <button
            onClick={() => handleMenuAction('earnings')}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
          >
            Earnings & Payouts
          </button>
          <div className="border-t border-gray-200 dark:border-slate-700 my-2" />
          <button
            onClick={handleLogoutClick}
            className="block w-full text-left px-4 py-2 text-sm text-red-600 dark:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};
